import apiCall from '../../apiCall/apiCall';
import buildUrlSearchParams from '../../apiCall/buildUrlSearchParams/buildUrlSearchParams';

// This class handles any API calls related to packages.
class Packages {
  static all(data) {
    const params = buildUrlSearchParams(data);
    return apiCall('GET', 'api/warehouses/packages', params);
  }
  static show(id) {
    return apiCall('GET', `api/warehouses/packages/${id}`);
  }

  static update(ids, data) {
    const params = { ids: ids, package: data };
    return apiCall('PATCH', 'api/warehouses/packages', params);
  }

  static manuallyComplete(id, reason) {
    const params = { reason: reason };
    return apiCall('POST', `/api/warehouses/packages/${id}/manually_complete`, params);
  }

  static manuallyUncomplete(id) {
    return apiCall('POST', `/api/warehouses/packages/${id}/undo_manual_completion`);
  }
}

export default Packages;
